module.exports = __webpack_public_path__ + "static/media/logo-no-circle.0f22e3b2.svg";